import { Alert, AlertType, Icon, ColorText, Dialog } from './model/snackbar.model';
import { SnackbarService } from './service/snackbar.service';
import { Component, OnInit } from '@angular/core';

@Component({
	//moduleId: module.id,f
	selector: 'app-snackbar',
	templateUrl: 'snackbar.component.html',
	styleUrls: ['./snackbar.component.css']
})
export class SnackbarComponent implements OnInit {
	alert: Alert;
	dialog: Dialog;

	constructor(private nackbarService: SnackbarService) { }

	ngOnInit() {
		this.alert = new Alert();
		this.dialog = new Dialog();

		this.nackbarService.getAlert().subscribe((alert: Alert) => {
			if (!alert) {
				this.alert.messages = [];
				return;
			}
			this.alert = alert;
		});

		/** Dialog */
		this.nackbarService.getDiag().subscribe((dialog: Dialog) => {
			if (!dialog) {
				this.dialog.message = '';
				return;
			}
			this.dialog = dialog;
		});
	}

	onCloseMsg() {
		this.removeAlert();
	}

	removeAlert() {
		this.alert.messages = [];
	}

	getCssClassMsg() {
		if (!this.alert) {
			return;
		}

		switch (this.alert.type) {
			case AlertType.success:
				return this.alert.messages.length > 0 ? 'view-snackbar success' : 'success';
			case AlertType.error:
				return this.alert.messages.length > 0 ? 'view-snackbar danger' : 'danger';
			case AlertType.info:
				return this.alert.messages.length > 0 ? 'view-snackbar info' : 'info';
			case AlertType.warning:
				return this.alert.messages.length > 0 ? 'view-snackbar warning' : 'warning';
		}
	}

	getIconMsg() {
		if (!this.alert) {
			return;
		}

		switch (this.alert.icon) {
			case Icon.success:
				return 'check_circle';
			case Icon.error:
				return 'error';
			case Icon.info:
				return 'info_outline';
			case Icon.warning:
				return 'warning';
		}
	}

	/** Dialog */
	onNoDiag(){
		this.removeDialog();
	}

	onSiDiag(){
		this.dialog.event();
		this.removeDialog();
	}

	removeDialog() {
		this.dialog.message = '';
	}

	getCssClassDiag(){
		return String(this.dialog.message != '' ? 'view-snackbar' : '');
	}

	getColorText(){
		if (!this.dialog) {
			return;
		}

		switch (this.dialog.colorText) {
			case ColorText.green:
				return 'text-green-dialog';
			case ColorText.red:
				return 'text-red-dialog';
		}
	}
}
